import React, { useEffect, useState } from 'react'
import { Progress } from 'reactstrap'

import AWS from 'aws-sdk'
import { urlBucketS3 } from '../../constants/urls';



const ComponentButtonS3 = ({ value, onChange, validate, validationCallback, hasError, mensajeError, tipo }) => {

    const [progress, setProgress] = useState(0);
    const [accessKey, setAccessKey] = useState(null)
    const [bucket, setBucket] = useState(null)
    const [region, setRegion] = useState(null)
    const [secretKey, setSecretKey] = useState(null)

    useEffect(() => {
        obtenerDatosBucket()
    }, [])

    /**
     * 
     * @param {*} e evento de cambio de archivo
     */
    const handleFileInput = (e) => {
        uploadFile(e.target.files[0])
    }

    /**
     * Función para obtener credenciales del bucket en S#
     */
    const obtenerDatosBucket = async () => {

        var url = urlBucketS3;

        try {
            const response = await fetch(url)
            const json = await response.json()
            if (json.transaccion) {
                setAccessKey(json.bucketimagenesaig.accessKey)
                setBucket(json.bucketimagenesaig.bucket)
                setRegion(json.bucketimagenesaig.region)
                setSecretKey(json.bucketimagenesaig.secretKey)

            } 



        } catch (error) {

        }

        window.scrollTo(0, 0);





    }

    /**
     * Función para subir un archibo al  S3
     * @param {*} file 
     */
    const uploadFile = (file) => {
        AWS.config.update({
            accessKeyId: accessKey,
            secretAccessKey: secretKey
        })

        const myBucket = new AWS.S3({
            params: { Bucket: bucket },
            region: region,
        })

        setProgress(0)

        const params = {
            ACL: 'public-read',
            Body: file,
            Bucket: bucket,
            Key: file.name
        };


        myBucket.putObject(params)

            .on('httpUploadProgress', (evt) => {
                setProgress(Math.round((evt.loaded / evt.total) * 100))
            })
            .send((err) => {
                if (err) {
                    validationCallback(true)
                } else {
                    validationCallback(false)
                    myBucket.getSignedUrl('putObject', params, function (error, url) {
                        if(!error){
                            onChange(url.split('?')[0])
                        }
                       
                    });
                }
                setProgress(0)
            })

    }


    return (
        <div>

            <label htmlFor="formId">

                <input

                    type="file"

                    onChange={handleFileInput}
                    id="formId"
                    accept={tipo}
                    hidden
                    target='_blank'
                    rel='noopener noreferrer'

                >

                </input>

                <div
                    className='btn btn-detail-white'
                    style={{ backgroundColor: '#001871', color: 'white' }}
                >

                    <div>
                        <i
                            className='fa fa-cloud-upload'
                            aria-hidden='true'
                        />{" "}
                        {value == '' ? 'CARGAR ARCHIVO' : 'CAMBIAR ARCHIVO'}
                    </div>



                </div>

            </label>

            {
                (progress > 0 && progress < 100) &&
                <Progress
                    color="info"
                    style={{
                        backgroundColor: '#001871'
                    }}
                    value={progress}
                />

            }

            {
                (value != '' &&
                    progress == 0) &&
                <div>
                    <br></br>
                    <a href={value}>Descargar archivo</a>
                </div>
            }

            {hasError && validate ?
                <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{mensajeError}</div> : null
            }







        </div>
    )

}
export default ComponentButtonS3